import { render, staticRenderFns } from "./AdminProjectDetail.vue?vue&type=template&id=ff8bc3d2&scoped=true&lang=html&"
import script from "./AdminProjectDetail.vue?vue&type=script&lang=js&"
export * from "./AdminProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminProjectDetail.vue?vue&type=style&index=0&id=ff8bc3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8bc3d2",
  null
  
)

export default component.exports